export class TeamGoalSave {
    teamId: number;
    teamGoalIds: number[];
}
